import './social_profile_view.js.coffee'
Namespace 'Customer.Users'

class Customer.Users.InstagramProfileView extends Customer.Users.SocialProfileView
  template: JST['backbone/templates/customer/users/instagram_profile']
  id: 'instagram-profile'
